<script lang="ts">
  import ListNavigationItem from "$shared/components/ListNavigationItem.svelte";
  import NotLoggedInContentWrapper from "../components/NotLoggedInContentWrapper.svelte";
  import api, { fromApi, mapInto } from "$parkito-api";
  import { DebtorModel } from "$models";
  import {
    AddCardModal,
    Button,
    CardInline,
    CardsView,
    Col2Grid,
    Page,
    Toast,
    WithResource,
  } from "$components";

  type Props = {
    params: { debtorId: string; token: string };
  };
  const { params }: Props = $props();
  const publicDebtorData = fromApi(async () =>
    api.publicDebtorAndCardsGet({
      path: { id: params.debtorId },
      body: { authToken: params.token },
    })
      .then(
        mapInto((s) => ({ cards: s.cards, debtor: new DebtorModel(s) })),
      )
  );
  $publicDebtorData.load();

  const pageTitle = $publicDebtorData.map((d) =>
    [d.debtor.name, d.debtor.contactEmail].filter((i) => i).join(" - ")
  );

  let cardModal: AddCardModal | undefined = $state();
  async function onCardAdded() {
    await $publicDebtorData.reload();
    Toast.success("Kort har sparats");
  }
</script>

<NotLoggedInContentWrapper>
  <Page backButton={false} asyncTitle={pageTitle}>
    {#snippet content()}
      <WithResource api={publicDebtorData}>
        {#snippet child(data)}
          <Col2Grid>
            <CardInline title="Betalprofil">
              <div>
                <ListNavigationItem
                  title={data.debtor.isPerson()
                    ? "Personnummer"
                    : "Organisationsnummer"}
                  textRight={data.debtor.getSid()}
                  isFirst={true}
                />
                <ListNavigationItem title="Namn" textRight={data.debtor.name} />
                <ListNavigationItem
                  title="E-post - kontakt"
                  textRight={data.debtor.contactEmail ?? "-"}
                />
                <ListNavigationItem
                  title="Telefonnummer"
                  textRight={data.debtor.phone ?? "-"}
                  isLast={true}
                />
              </div>
            </CardInline>

            <CardInline title="Betalning">
              <div>
                <ListNavigationItem
                  title="Leveransmetod"
                  textRight={data.debtor.translateDeliveryMethodType()}
                  isFirst={true}
                  link={`#/profile/${data.debtor.id}/delivery-method`}
                  iconSrc="/icons/bankid-dark.svg"
                />
                <ListNavigationItem
                  title="Betalmetod"
                  textRight={data.debtor.translateDeliveryMethodType()}
                  link={`#/profile/${data.debtor.id}/payment-method`}
                  iconSrc="/icons/bankid-dark.svg"
                />
              </div>
            </CardInline>

            <CardInline title="Dina kort">
              <CardsView
                cards={data.cards}
                onRemoveCard={() => Promise.reject()}
                onSetDefault={() => Promise.reject()}
              />
              <Button
                onClick={() => cardModal?.openDialog()}
                text="Lägg till kort"
              ></Button>
            </CardInline>
          </Col2Grid>
        {/snippet}
      </WithResource>
      <AddCardModal
        bind:this={cardModal}
        debtorSetupCard={(id) =>
          api.publicDebtorSetupCard({
            path: { id },
            body: { authToken: params.token },
          })}
        debtorFinalizeCardSetup={(setupId, debtorId) =>
          api.publicDebtorFinalizeCardSetup({
            path: { debtorId, setupId },
            body: { cardName: "Kort", authToken: params.token },
          })}
        debtorId={params.debtorId}
        {onCardAdded}
      />
    {/snippet}
  </Page>
</NotLoggedInContentWrapper>
